<template>
  <generic-modal
    :title="$t('prescription')"
    ref="generic_modal"
    :is_wide="true"
  >
    <div class="form">
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('doctor')"
              :placeholder="$t('select one')"
              url="/patient/team/catalog"
              name_field="name"
              :is_multiple="false"
              value_field="team_member_id"
              @selected="set_doctor"
              ref="doctor_dropdown"
              :add_new="true"
              @add_new="create_doctor"
            />
          </div>
          <div v-if="selected_doctor">
            <div class="title is-6">
              <span>{{ selected_doctor.name }}</span>
            </div>
            <div class="subtitle is-6 mb-0" v-if="selected_doctor.phone">
              <span>
                <span class="icon">
                  <i class="fa fa-phone"></i>
                </span>
                {{ selected_doctor.phone }}
              </span>
            </div>
            <div class="subtitle is-6" v-if="selected_doctor.email">
              <span>
                <span class="icon">
                  <i class="fa fa-envelope"></i>
                </span>
                {{ selected_doctor.email }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("details") }}</label>
        <div class="control">
          <textarea
            class="textarea"
            rows="2"
            v-model="meta.settings.details"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <!-- <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import moment from "moment";

export default {
  name: "PrescriptionModal",
  components: {
    GenericModal,
    GenericCalendar,
    GenericDropdown,
  },
  data() {
    return {
      meta: { settings: {} },
      error: "",
      selected_doctor: null,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.settings || !v.meta.settings.details;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(args) {
      let v = this;
      v.set_initial_state();
      if (!args.patient_uuid) console.error("patient_uuid is required");
      v.meta.patient_uuid = args.patient_uuid;
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(prescription_uuid) {
      let v = this;
      v.set_initial_state();

      get("/patient/prescription", { uuid: prescription_uuid })
        .then((prescription) => {
          v.meta = prescription;

          if (prescription.doctor_team_member_id)
            v.$refs.doctor_dropdown.set_value(
              prescription.doctor_team_member_id
            );
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/patient/prescription", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/patient/prescription", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      v.$refs.doctor_dropdown.clear();
      v.selected_doctor = null;
      // v.uuid = "";
    },
    // remove() {
    //   let v = this;
    //   confirm_deletion_dialog(
    //     v.$t("are you sure to delete hospitalization?"),
    //     v,
    //     () => {
    //       del("/patient/hospitalization", { uuid: v.meta.uuid })
    //         .then(() => {
    //           v.$emit("success");
    //           v.$refs.generic_modal.close_modal();
    //         })
    //         .catch((error) => {
    //           error_message(error);
    //         });
    //     }
    //   );
    // },
    set_doctor(doctor) {
      let v = this;
      if (doctor) {
        v.selected_doctor = doctor;
        v.meta.doctor_id = doctor.team_member_id;
      }
    },
    create_doctor() {
      let v = this;
      v.$refs.team_modal.show_modal();
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
